"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("../SharedButton.scss");
require("./TextButton.scss");
const TextButton = (props) => {
    const handleClick = (event) => {
        event.preventDefault();
        props.disabled !== true && props.action();
    };
    return (react_1.default.createElement("button", { className: `ff-component-text-button ${props.disabled ? "ff-button-disabled" : ""} ${props.className || ""}`, onClick: handleClick, ref: props.myRef }, props.children));
};
exports.default = TextButton;
//# sourceMappingURL=TextButton.js.map